import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { PageStatusResult } from '../pageStatusTypes';
import { getNumericResponseTime, getResponseTimeColor } from '../pageStatusUtils';

type PageStatusResponseTimeBadgeProps = {
  responseTime: PageStatusResult['response_time'];
};

export const PageStatusResponseTimeBadge: FC<PageStatusResponseTimeBadgeProps> = ({ responseTime }) => {
  const numericResponseTime = getNumericResponseTime(responseTime);

  if (numericResponseTime === null) {
    return <Typography variant='body2'>N/A</Typography>;
  }

  return (
    <Box
      component='span'
      sx={{
        display: 'inline-block',
        minWidth: 72,
        px: 1,
        py: 0.25,
        borderRadius: 999,
        textAlign: 'center',
        fontWeight: 700,
        color: 'white',
        backgroundColor: getResponseTimeColor(numericResponseTime),
      }}>
      {numericResponseTime} ms
    </Box>
  );
};
